import apiUseCases from "@src/cloud-connect/api";
import { GetGatewayOperationStatusResponse } from "@src/types/gateway-onboarding";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export interface QueryGatewayOperationStatusResult {
  success: boolean;
  data?: GetGatewayOperationStatusResponse;
  error?: string;
  errorData?: unknown;
  status?: number;
}

export const queryGatewayOperationStatusUseCase = async (
  operationId: string,
  signal?: AbortSignal,
): Promise<QueryGatewayOperationStatusResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext?.customerNamespace;

    const response = await apiUseCases.getGatewayOperationStatus(
      namespace,
      operationId,
      signal,
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    if (signal?.aborted) {
      throw error;
    }

    const parsed = parseAxiosApiError(
      error,
      "Failed to fetch gateway operation status.",
    );

    return {
      success: false,
      error: parsed.message,
      errorData: parsed.data,
      status: parsed.status,
    };
  }
};
